import React from 'react';

/**
 * QR code glyph (CIN-6585).
 *
 * Added because the icon set had no QR mark and the nearest stand-in, GridFilledIcon, is
 * already the Apps submenu icon -- sharing it would make two unrelated nav entries look the
 * same. Follows the same shape as every other icon here: 24x24, single path, `fill` prop.
 */
function Icon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={props.size || 24} height={props.size || 24} fill={props.fill || '#1D252D'} viewBox="0 0 24 24">
      <path d="M3 3h8v8H3V3zm2 2v4h4V5H5zm8-2h8v8h-8V3zm2 2v4h4V5h-4zM3 13h8v8H3v-8zm2 2v4h4v-4H5zm8-2h2v2h-2v-2zm4 0h2v2h-2v-2zm2 2h2v2h-2v-2zm-4 2h2v2h-2v-2zm-2 2h2v2h-2v-2zm4 0h2v2h-2v-2zm2 2h2v2h-2v-2zM6 6h2v2H6V6zm10 0h2v2h-2V6zM6 16h2v2H6v-2z" />
    </svg>;
}
export default Icon;